/**
 * Floating Agent
 * 
 * @Author: Focci
 * @Date: 2023-08-11 10:55:43
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 10:55:43
 */

'use client'

import PropTypes from 'prop-types'
import StickyBar from '@comp/sticky-bar'
import useApp from '@hook/useApp'
import useLazyComponent from '@hook/useLazyComponent'
import { useEffect, useRef, useState } from 'react'

export default function FloatingAgent({
  house = {},
  isModal
}) {
  const { isMobile } = useApp()
  const { Wedget: FloatingAgentBar, getWedget } = useLazyComponent()

  const ele = useRef()
  const [target, setTarget] = useState()
  
  useEffect(() => {
    !isMobile && getWedget(() => import('./FloatingAgentBar'))
  }, [getWedget, isMobile])

  useEffect(() => {
    if(isModal) {
      let el = ele.current.getEl()
      while(el) {
        if(el.classList.contains('MuiDialog-paperScrollBody')) {
          setTarget(el)
          break
        }
        el = el.parentNode
      }
      setTarget(el)
    }
  }, [isModal])
  
  return (
    <StickyBar target={target} ref={ele}>
      <div className="hidden lg:block bg-info animate-fade-in absolute left-0 right-0">
        <FloatingAgentBar house={house} isModal={isModal} />
      </div>
    </StickyBar>
  )
}

FloatingAgent.propTypes = {
  house: PropTypes.object,
}
